import * as homepageTagActions from '../../action_creators/homepage/homepage_tag_action_creators';
import HomepageTagModel from '../../../models/homepage/homepage_tag_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageTagActions.homepageTagLoading({}, store));
    return HomepageTagModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(homepageTagActions.homepageTagLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(homepageTagActions.homepageTagLoadError(err, store));
        log.error(
          err,
          `Error in homepage tag actions, message: ${err.message}`
        );
      });
  };
}
